export enum AbsenceType {
  VACATION = "VACATION",
  SICK_LEAVE = "SICK_LEAVE",
}
